import isNumber from 'lodash/isNumber';
import { post } from '../../../../../shared/utils/http';

import { initialiseCommonStore } from '../../../../../shared/components/react/CommonDataStore/actions';
import {
    COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS,
    COMMON_REDUX_STORE_UPDATE_FROM_BACKEND,
} from '~shared/components/react/CommonDataStore/actionTypes';
import mainSocket from '../../../../../shared/services/mainSocketClass';

import { updateMetaData } from '../../../../../shared/components/react/MetaDataStore/actions';
import { buildSpectateUrl } from '../../../../../spa/Utils/Spectate';
import {
    COMMON_DATA_LIST_EVENTS_ERROR,
    COMMON_DATA_LIST_EVENTS_LOADING_SUCCESS,
    COMMON_DATA_LIST_EVENTS_START_LISTENING_FOR_WS_UPDATES,
    COMMON_DATA_LIST_EVENTS_STOP_LISTENING_FOR_WS_UPDATES,
    COMMON_DATA_LIST_EVENTS_UPDATE_MARKET_ID,
} from '../actions/commonDataListEventsActionsTypes';
import { eventIsOver } from '../../../sport-event/utils';

export const commonDataListEventsErrorOccurred = bool => {
    return {
        type: COMMON_DATA_LIST_EVENTS_ERROR,
        errorOccurred: bool,
    };
};

export const getWidgetEvents = (
    wsEventListener,
    postURL,
    postParams,
    postOptions,
    isFunctionalComponent = false
) => {

    return async (dispatch) => {
        try {

            const response = await post(
                buildSpectateUrl(postURL),
                postParams,
                postOptions
            );
            if (!response.ok) {
                dispatch(commonDataListEventsErrorOccurred(true));

                return Object.getPrototypeOf(Function);
            }

            const data = await response.json();
            if (!data?.events || data.events.length === 0) {

                // some endpoints (e.g. getOddsBoostEventsAjax) return an empty array
                // also check for empty data.events in case of a malformed event in CMS
                return Object.getPrototypeOf(Function);
            }

            // Decorate the slice events with the sport slug. This can be removed on
            // completion of following story
            // @todo https://dedsert.atlassian.net/browse/AM-5657
            data.event_order.forEach((eventOrderEvent, index) => {
                const { event_id } = eventOrderEvent;
                data.event_order[index].sportSlug = data.events[event_id].sport_slug;
            });

            const [{ sport_slug: sportSlug = '' }] = Object.values(data.events);
            dispatch([
                updateMetaData({
                    matchRequestLimit: data.match_request_limit,
                    widgetQuickLinks: data.widget_quick_links,
                }),
                initialiseCommonStore(data.events),
                startListeningForWsUpdates(data.selection_pointers),
                widgetEvents(data.event_order, sportSlug),
            ]);
            if (data.selection_pointers.length) {
                return mainSocket.onWsEventUpdate((wsData) => {
                    const { events, action } = wsData;
                    if (action === 'event_off') {
                        /**
                         * Tricky - do we unsubscribe? If we do then we will not get an inplay_start message
                         * (if a corresponding inplay event is booked). If we don't we remain subscribed to
                         * an event that may never go inplay. I'm going with don't unsubscribe and leaving
                         * this here as a hint to future readers. We should unsubscribe from the off'd event
                         * when the component unmounts anyway.
                         */
                        // dispatch(stopListeningForUpdates(events));
                    }

                    if (action === 'inplay_update') {
                        const endedEvents = events.filter(event => !isNumber(event) && eventIsOver(event.match_status));
                        if (endedEvents.length) {
                            dispatch(stopListeningForUpdates(endedEvents));
                        }
                    }

                    if (isFunctionalComponent) {
                        dispatch(wsEventListener(wsData));
                    } else {
                        wsEventListener(wsData);
                    }
                });
            }
        } catch (e) {
            dispatch(commonDataListEventsErrorOccurred(true));
        }

        return Object.getPrototypeOf(Function);
    };
};

/**
 * Action creator - populate common stores on load
 * @param {Array} events widget events
 * @param {String} sportSlug (optional) single sport slug - used for pp-ip transitions. To be
 *  deprecated when sports pages all use new (v2) layouts
 * @returns {Object} redux action
 */
export const widgetEvents = (events, sportSlug = '') => {
    return {
        type: COMMON_DATA_LIST_EVENTS_LOADING_SUCCESS,
        events,
        sportSlug,
    };
};

export const updateWidgetEventsWithNewMarketId = (newSelectionPointers = []) => ({
    type: COMMON_DATA_LIST_EVENTS_UPDATE_MARKET_ID,
    newSelectionPointers,
});

export const startListeningForWsUpdates = (selectionPointers = []) => {
    return {
        type: COMMON_DATA_LIST_EVENTS_START_LISTENING_FOR_WS_UPDATES,
        selectionPointers,
    };
};

export const stopListeningForUpdates = (events) => {
    return {
        type: COMMON_DATA_LIST_EVENTS_STOP_LISTENING_FOR_WS_UPDATES,
        events,
    };
};

export const updateCommonStoreWsData = wsData => {
    return {
        type: COMMON_REDUX_STORE_UPDATE_FROM_WEBSOCKET_EVENTS,
        wsData: wsData,
    };
};

export const updateCommonStoreFromBe = (data) => ({
    type: COMMON_REDUX_STORE_UPDATE_FROM_BACKEND,
    data,
});
